// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"2fd563cf","129":"3039d4fa","210":"6ee6a6e2","437":"3039d4fa","765":"b1b30c22","907":"3039d4fa"}[chunkId] + ".chunk.css";
};